// apps/client/src/state/slices/session.ts (M0-T10, §8.7)
import type { ConfigResponse, MeResponse } from '@whiskerton/shared';
import { api } from '../../api/endpoints';
import type { SliceCreator } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- declaration merging into GameStore
declare module '../types' { interface GameStore extends SessionSlice {} }

export interface SessionSlice {
  config: ConfigResponse | null; me: MeResponse | null; signedIn: boolean;
  setConfig(c: ConfigResponse): void; setMe(m: MeResponse | null): void; signOut(): Promise<void>;
}
export const slice: SliceCreator<SessionSlice> = (set) => ({
  config: null, me: null, signedIn: false,
  setConfig: (config) => set({ config }),
  setMe: (me) => set({ me, signedIn: me !== null }),
  async signOut() {
    try { await api.signOut(); } catch { /* the token is cleared either way */ }
    set({ me: null, signedIn: false, phase: 'signedOut', screens: [], townsNotice: null });   // the notice named the last account's town
  },
});
